// Server / process monitor HTTP wrappers (admin only).
import { api } from './api.js';

export async function listProcesses(connectionId) {
  const r = await api.get(`/api/connections/${connectionId}/processlist`);
  return r.processes || [];
}

// mode: 'connection' (KILL id) or 'query' (KILL QUERY id). Returns { results }.
export async function killProcesses(connectionId, ids, mode) {
  return api.post(`/api/connections/${connectionId}/kill`, { ids, mode });
}

// Open InnoDB transactions (any client, subject to MySQL PROCESS privilege).
export async function listTransactions(connectionId) {
  const r = await api.get(`/api/connections/${connectionId}/transactions`);
  return r.transactions || [];
}
